import CategoriesDropdown from './CategoriesDropdown.js';

/**
 * Ressources class.
 */
export default class CategoriesDropdownForm extends CategoriesDropdown {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    ...CategoriesDropdown.config,
    name: 'CategoriesDropdownForm',
    refs: ['tagsList', 'categories[]', 'btn', ...CategoriesDropdown.config.refs],
  };

  /**
   * [onCategoriesClick description]
   * @param  {object} e
   * @returns {void}
   */
  onCategoriesClick(e) {
    const element = e.currentTarget;
    const { link, name, slug } = element.dataset;

    this.$refs.btn.setAttribute('href', `${link}`);
    this.$refs.selected.textContent = name;

    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=get_tags&security=custom_nonce&cat=${slug}`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$refs.tagsList.innerHTML = response.data;
      });

    setTimeout(() => {
      document
        .querySelector('.ressources__cat--current')
        .classList.remove('ressources__cat--current');
      element.classList.add('ressources__cat--current');
    }, 500);
  }
}
